// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Patient } from '@medplum/fhirtypes';

/**
 * Returns a copy of `patient` whose `meta.tag` array has any entries with the given
 * `tagSystem` removed and a single new entry `{ system: tagSystem, code }` appended.
 * Other tags are preserved.
 */
export function setPatientStatusTag(patient: Patient, tagSystem: string, code: string): Patient {
  const existingTags = patient.meta?.tag ?? [];
  const tag = { system: tagSystem, code };
  const nextTags = [...existingTags.filter((t) => t.system !== tagSystem), tag];

  return {
    ...patient,
    meta: {
      ...patient.meta,
      tag: nextTags,
    },
  };
}
